<template>
  <div id="page-strains-list">
    <div class="vx-card p-6">
      <vs-table
        id="strain__list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="500px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        pagination
        :max-items="this.length"
        search
        :data="strains"
      >
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">
                    {{ page * length - (length - (FilteredCount && 1)) }}
                    -
                    {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                    of {{ FilteredCount }} (filtered from {{ total }} total entries)
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="handleChangeLength(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>

          <div
            v-if="checkPermissionByIds([permissions.STRAIN_ADD])"
            @click="toggleAddStrainModal"
            class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add Strain</span>
          </div>
        </template>

        <template slot="thead">
          <vs-th sort-key="batch.id">Sr#</vs-th>
          <vs-th sort-key="batch.batch_name">Strain Name</vs-th>
          <vs-th sort-key="batch.description">Testing Status</vs-th>
          <vs-th sort-key="batch.batch_number">THC level</vs-th>
          <vs-th sort-key="batch.batch_number">CBD level</vs-th>
          <vs-th sort-key="batch.batch_number">Indica Percentage</vs-th>
          <vs-th sort-key="batch.batch_number">Sativa Percentage</vs-th>
          <vs-th v-if="checkPermissionByIds([permissions.STRAIN_EDIT])">Status</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              {{ data[i].name }}
            </vs-td>
            <vs-td>
              {{ data[i].testing_status }}
            </vs-td>
            <vs-td>
              {{ data[i].thc_level }}
            </vs-td>
            <vs-td>
              {{ data[i].cbd_level }}
            </vs-td>
            <vs-td>
              {{ data[i].indica_percentage }}
            </vs-td>
            <vs-td>
              {{ data[i].sativa_percentage }}
            </vs-td>
            <vs-td v-if="checkPermissionByIds([permissions.STRAIN_EDIT])">
              <vs-switch color="primary" :value="tr.status" @input="updateStatus(tr.id, !tr.status)">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
            </vs-td>
            <vs-td :data="tr.id">
              <div class="inline-flex" v-if="checkPermissionByIds([permissions.STRAIN_EDIT]) || checkPermissionByIds([permissions.STRAIN_DELETE])" :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                <vx-tooltip v-if="checkPermissionByIds([permissions.STRAIN_EDIT])" text="Edit Strain Name">
                  <feather-icon icon="Edit3Icon" v-if="checkPermissionByIds([permissions.STRAIN_EDIT])" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="sendToEditPage(tr.id)" />
                </vx-tooltip>
                <vx-tooltip v-if="checkPermissionByIds([permissions.STRAIN_DELETE])" text="Delete Strain">
                  <feather-icon icon="Trash2Icon" v-if="checkPermissionByIds([permissions.STRAIN_DELETE])" svgClasses="h-5 w-5  hover:text-danger cursor-pointer" @click="deleteRecord(tr.id)" />
                </vx-tooltip>
              </div>
              <div v-else>-</div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- add strain modal -->
    <add-strain-modal v-if="isAddStrainModalMounted" :showModal.sync="isAddStrainModalShow" @updateList="getData" />

    <!-- edit strain modal -->
    <edit-strain-modal v-if="isEditStrainModalMounted" :showModal.sync="isEditStrainModalShow" :strainId="selectedStrainId" @updateList="getData" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AddStrainModal from '@/views/strains/AddStrain'
import EditStrainModal from '@/views/strains/EditStrain'

export default {
  name: 'StrainList',

  components: {
    AddStrainModal,
    EditStrainModal
  },

  data: () => ({
    order: [],
    length: 10,
    page: 1,
    search: '',
    loading: false,
    selectedStrainId: null,

    // add strain
    isAddStrainModalMounted: false,
    isAddStrainModalShow: false,

    // edit strain
    isEditStrainModalMounted: false,
    isEditStrainModalShow: false
  }),

  mounted() {
    this.getData()
  },

  computed: {
    ...mapState('strain', ['strains', 'total', 'FilteredCount']),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds'])
  },

  methods: {
    sendToEditPage(id) {
      this.selectedStrainId = id
      this.isEditStrainModalMounted = true
      this.isEditStrainModalShow = true
    },

    // toggle track item modal
    toggleAddStrainModal() {
      this.isAddStrainModalMounted = true
      this.isAddStrainModalShow = true
    },

    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteStrain(id),
        acceptText: 'Delete'
      })
    },

    deleteStrain(id) {
      this.loading = true
      this.$store
        .dispatch('strain/delete', id)
        .then(() => {
          if (this.strains.length === 1 && this.page !== 1) {
            this.page -= 1
          }
          this.loading = false
          this.$vs.notify({
            title: 'Success',
            text: 'Strain deleted successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    getData() {
      const { page, length, order, search } = this
      this.loading = true

      this.$store
        .dispatch('strain/getStrains', {
          page,
          limit: length,
          order,
          search
        })
        .finally(() => {
          this.loading = false
        })
    },

    // update strain status
    updateStatus(id, status) {
      this.loading = true
      this.$store
        .dispatch('strain/updateStrainStatus', {
          id,
          status
        })
        .then(() => {
          this.loading = false
          this.$vs.notify({
            title: 'Success',
            text: 'Strain status updated successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#strain__list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#strain__list > .con-vs-loading')
      }
    },

    isEditStrainModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditStrainModalMounted = false
            this.selectedStrainId = null
          }, 0)
        }
      }
    },

    isAddStrainModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddStrainModalMounted = false
          }, 0)
        }
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.isAddStrainModalShow = false
    this.isEditStrainModalShow = false

    next()
  }
}
</script>
